import { Grid } from "@material-ui/core";
import { Checkbox } from "@components";
import classNames from "classnames";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { arrayOf, number, object, shape, string } from "prop-types";

export const SplitLevelsSelect = ({
  control,
  name,
  workTypes,
  usedWorkTypes,
  issueTypes,
  usedMaps,
}) => {
  const {t} = useTranslation();
  
  const handleCheckboxChange = (onChange, value, id) => (e) => {
    const newV = e.currentTarget.checked
      ? [...value, id]
      : value.filter((v) => v !== id);
    onChange(newV);
  };
  
  return (
    <Controller
      name={name}
      control={control}
      render={({
        field: { onChange, value, name },
        fieldState: { error },
      }) => (
        <Grid item container direction="column" wrap="nowrap">
          {
            usedMaps.map((id) => {
              const checked = value?.includes(id);
              const issueName = issueTypes.find(i => i.id === id).name;
              
              return (
                <Checkbox
                  key={issueName}
                  name={name}
                  error={!!error}
                  checked={checked}
                  onChange={handleCheckboxChange(onChange, value, id)}
                  label={
                    <>
                      { issueName }
                      <i className="text-lighter ml-2">
                        {`(${t("common.eg")} `}
                        {
                          checked
                          ? usedWorkTypes
                            .slice(0, 2)
                            .map(w => `${issueName} 1 ${workTypes.find(wt => wt.id === w).name || t("common.unnamed")}, `)
                            : `${issueName} 1`
                        }
                        {`${checked ? t("common.etc") : ""})`}
                      </i>
                    </>
                  }
                  className={classNames("my-1")}
                />
              )
            })
          }
          { !!error && <span className="mt-2 color-error">{error?.message}</span> }
        </Grid>
      )}
    />
  )
}

SplitLevelsSelect.propTypes = {
  control: object.isRequired,
  name: string.isRequired,
  workTypes: arrayOf(shape({
    id: number.isRequired,
    name: string.isRequired,
  })).isRequired,
  usedWorkTypes: arrayOf(number).isRequired,
  issueTypes: arrayOf(shape({
    id: string.isRequired,
    name: string.isRequired,
  })).isRequired,
  usedMaps: arrayOf(string).isRequired,
}